import React, { useContext, useEffect, useState } from "react";
import "../assets/css/sidebar.css";
import "../assets/css/style.css";
import picon from "../assets/img/peple-like-i.svg"
import downarrows from "../assets/img/dropdown.svg"
import contimg from "../assets/img/contact-svgrepo-com 1.svg"
import faq from "../assets/img/help-circle.svg"
import l1 from "../assets/img/l1.svg"
import logout from "../assets/img/log-out.svg"
import l2 from "../assets/img/l2.svg"
import adds from "../assets/img/add-square-svgrepo-com 1.svg"
import { Link } from "react-router-dom";
import profileimg from "../assets/img/profile/profile-img.svg"
import { useNavigate, useLocation } from 'react-router-dom';
import { CommunityContext } from "../config/CommunityContext";
import { FollowOrganizationContext } from "../config/FollowOrganizationContext";
import "../assets/css/header.css"
import Cookies from 'js-cookie';
import { API } from "../services/api";
const SideBar = () => {
   const location = useLocation();
   const currentPath = location.pathname
   const { communities, pendingCommunities } = useContext(CommunityContext);
   const { followOrganizations } = useContext(FollowOrganizationContext);
   const [isMyComm, setIsMyComm] = useState(true);
   const [isBreastCan, setIsBreastCan] = useState(false);
   const [isOrganizationsOpen, setIsOrganizationsOpen] = useState(true);
   const [isOtherLinksOpen, setIsOtherLinksOpen] = useState(false);
   const [expandedCommunities, setExpandedCommunities] = useState({});
   const [Communities, setCommunities] = useState([]);
   const userData = JSON.parse(localStorage.getItem('userData'));
   const navigate = useNavigate();



   useEffect(() => {
      const storedExpanded = JSON.parse(localStorage.getItem("expandedCommunities"));
      if (storedExpanded) {
         setExpandedCommunities(storedExpanded);
      }
   }, []);

   useEffect(() => {
      const storedExpanded = JSON.parse(localStorage.getItem("expandedCommunities"));
      if (storedExpanded) {
         setExpandedCommunities(storedExpanded);
      }
   }, []);
   useEffect(() => {
      localStorage.setItem("expandedCommunities", JSON.stringify(expandedCommunities));
   }, [expandedCommunities]);
   useEffect(() => {
      const selectedCommunityId = localStorage.getItem("communityId");

      if (currentPath.startsWith("/feed/")  && selectedCommunityId) {
         setExpandedCommunities(prev => ({
            ...prev,
            [selectedCommunityId]: true
         }));
      }
   }, [currentPath]);


   return (
      <div>
         <nav class="sidebar sidebar-offcanvas sidebar-dh" id="sidebar">

            <div className="dh-home">
               {userData && userData.userType !== 'organization' ? (
                  <Link to="/justlikeme">
                     <button className={currentPath === '/justlikeme' ? "people-home-dh active" : "people-home-dh"}>
                        <img src={picon} className="plm-icon" alt="People Like Me" />
                        <p className="people-like-text">Just Like Me</p>
                     </button>
                  </Link>
               ) : (
                  <Link to="/discussions">
                     <button className={currentPath === '/discussions' ? "people-home-dh active" : "people-home-dh"}>
                        <img src={userData?.profileImage?.url ? API.uploadFilePath + userData?.profileImage?.url : profileimg} className="plm-icon" alt="Organization" />  {/* Added alt */}
                        <p className="people-like-text">{userData.firstName}</p>
                     </button>
                  </Link>
               )}
            </div>
            <hr className="seperator" />
            <div className="dh-dynamic-menu">
               <div class=" side-menus-itm-dh">
                  <button
                     className="main-menu-itm-dh"
                     type="button"
                     onClick={() => setIsMyComm(!isMyComm)}
                  >
                     <span>My Communities</span>
                     <img
                        src={downarrows}
                        alt="Arrow"
                        className={`arrowrrs-img ${isMyComm ? "arrowrrs-rotate" : ""} bulider-arrw`}
                     />
                  </button>
                  {isMyComm &&
                     <ul class="custom-submenu-dh">
                        
                        {communities.map((community) => {
                           if (!community || !community.communityId) return null;
                           const communityKey = community.communityId?._id; // each item has its own unique _id

                           const isExpanded = expandedCommunities[communityKey] || false;
                           return (
                              <li className="" key={communityKey}>
                                 <div className="dropdown-item main-dropdown">
                                    <button
                                       className="list-itm-dh"
                                       type="button"
                                       onClick={() =>
                                          setExpandedCommunities((prev) => ({
                                             ...prev,
                                             [communityKey]: !prev[communityKey], // toggle only this one
                                          }))
                                       }
                                    >
                                       <div className="d-flex align-items-center" >
                                          <img src={community?.communityId?.profileImage?.url ? API.uploadFilePath + community?.communityId?.profileImage?.url : profileimg} alt="icon" className="side-dh-com-thumb" />
                                          <span className="community-name-dh text-truncate" title={community.communityId?.communityName}>
                                             {community.communityId?.communityName}
                                          </span>
                                          {community.membertypeId?.memberTypeDisplayName !== "other" && community.membertypeId && <span className="avatarname-wrp">{community.membertypeId?.memberTypeDisplayName}</span>}
                                       </div>
                                       <img
                                          src={downarrows}
                                          alt="arrow"
                                          className={`arrowrrs-imgs ${isExpanded ? "arrowrrs-rotate" : ""
                                             } bulider-arrw`}
                                       />
                                    </button>
                                    {isExpanded && (
                                       <div className="subs-heads-dh">
                                          <ul className="dropdown-submenu-dh">
                                             <li className="sub-sub-menu-dh" >
                                                <Link
                                                   className={
                                                      currentPath === `/feed/${community.communityId.communityName.trim().replace(/\s+/g, '-').toLowerCase()}` &&
                                                         localStorage.getItem("communityId") === community.communityId._id
                                                         ? "comm-sub-dh active"
                                                         : "comm-sub-dh"
                                                   }
                                                   to={`/feed/${community.communityId.communityName.trim().replace(/\s+/g, '-').toLowerCase()}`}
                                                   onClick={() => {
                                                      localStorage.setItem(
                                                         "communityId",
                                                         community.communityId._id
                                                      );
                                                      localStorage.setItem(
                                                         "communityName",
                                                         community.communityId?.communityName
                                                      );
                                                      localStorage.setItem("communityData", JSON.stringify(community?.communityId));
                                                      navigate(`/feed/${community.communityId.communityName.trim().replace(/\s+/g, '-').toLowerCase()}`, { state: { refresh: true } });
                                                      
                                                   }
                                                   }
                                                >
                                                   Community Feed
                                                </Link>
                                             </li>
                                             <li className="sub-sub-menu-dh">
                                                <Link
                                                   className={
                                                      currentPath === `/event/${community.communityId.communityName.trim().replace(/\s+/g, '-').toLowerCase()}` &&
                                                         localStorage.getItem("communityId") === community.communityId._id
                                                         ? "comm-sub-dh active"
                                                         : "comm-sub-dh"
                                                   } to= {`/event/${community.communityId.communityName.trim().replace(/\s+/g, '-').toLowerCase()}`}
                                                   onClick={() => {
                                                      localStorage.setItem(
                                                         "communityId",
                                                         community.communityId._id
                                                      );
                                                      localStorage.setItem(
                                                         "communityData",
                                                         JSON.stringify(community?.communityId)
                                                      );
                                                      navigate(`/event/${community.communityId.communityName.trim().replace(/\s+/g, '-').toLowerCase()}`);
                                                      window.location.reload();
                                                   }} >
                                                   Upcoming Events
                                                </Link>
                                             </li>
                                          </ul>
                                       </div>
                                    )}
                                 </div>
                              </li>
                           );
                        })}
                        {pendingCommunities?.length > 0 && (
                           <>
                              {pendingCommunities.map((community) => {
                                 const communityKey = community?.requestedUserId;
                                 return (
                                    <li className="" key={communityKey}>
                                       <div className="dropdown-item main-dropdown">
                                          <button
                                             className="list-itm-dh"
                                             type="button"
                                          >
                                             <div className="d-flex align-items-center" >
                                                <img src={l2} alt="icon" className="side-dh-com-thumb" />
                                                <span className="community-name-dh text-truncate" title={community?.communityName}>
                                                   {community?.communityName}
                                                </span>
                                                <span className="avatarname-wrp">Pending</span>
                                             </div>

                                          </button>
                                       </div>
                                    </li>
                                 );
                              })}
                           </>
                        )}

                     </ul>
                  }
                  <div class="join-btn" role="group"
                     aria-label="Basic outlined example">


                     <Link to="/joinacommunity"
                        className={currentPath === '/joinacommunity' ? "join-btn-dh active" : "join-btn-dh"}>
                        <img src={adds} className="join-icondh" />
                        Join a Community</Link>


                  </div>
               </div>
               <hr className="seperator" />
               {userData && userData.userType !== 'organization' ? (
                  <div class="side-menus-itm-dh">
                     <button
                        className="main-menu-itm-dh"
                        type="button"
                        onClick={() => setIsOrganizationsOpen(!isOrganizationsOpen)}
                     >
                        <span>Organizations You Follow</span>
                        <img
                           src={downarrows}
                           alt="Arrow"
                           className={`arrowrrs-img ${isOrganizationsOpen ? "arrowrrs-rotate" : ""} bulider-arrw`}
                        />
                     </button>
                     {isOrganizationsOpen &&
                        <ul class="custom-submenu-dh">
                           {
                              followOrganizations.map((organizations) => {
                                if (organizations?.organizationId){
                                 return (
                                    <li className="">
                                          <Link
                                             className="dropdown-item main-dropdown"
                                             to={`/organization/view/${organizations?.organizationId?.firstName.trim().replace(/\s+/g, '-').toLowerCase()}`}
                                             onClick={() => {
                                                localStorage.setItem("communityName", organizations?.organizationId?.firstName);
                                                localStorage.setItem("communityData", JSON.stringify(organizations?.organizationId));
                                             }}
                                          >
                                          <button className="list-itm-dh" type="button" onClick={() => { setIsBreastCan(!isBreastCan) }}>
                                             <div className="d-flex align-items-center">
                                                <img src={organizations?.organizationId?.profileImage?.url ? API.uploadFilePath + organizations?.organizationId?.profileImage?.url : profileimg} alt="icon" className="side-dh-com-thumb" />
                                                <span className="community-name-dh text-truncate"> {organizations.organizationId.firstName}</span>
                                             </div>
                                          </button>
                                       </Link>
                                    </li>
                                 )
                              }
                              })
                           }

                           

                        </ul>
                     }
                     <div class="join-btn" role="group"
                        aria-label="Basic outlined example">

                        <Link to="/followanorganization"
                           className={currentPath === '/followanorganization' ? "join-btn-dh active" : "join-btn-dh"}>
                           <img src={adds} className="join-icondh" />
                           Follow an Organization</Link>


                     </div>
                     
                  </div>) : (null)}
               <hr className="seperator" />
               <div class="side-menus-itm-dh">
                  <button
                     className="main-menu-itm-dh mt-dis"
                     type="button"
                     onClick={() => navigate('/media')}
                  >
                     <span>Dreamers Health
                        Media</span>
                     <img
                        src={downarrows}
                        alt="Arrow"
                        className={`arrowrrs-img  bulider-arrw`}
                     />
                  </button>
                  
               </div>
               
               <hr className="seperator" />
            </div>
            <div className="dh-sidebar-footer">
               <div className="">
                 
               </div>
               <div className="conditions-dh" >
                  <p className="dh-policy"><Link to="/privacy-policy">Privacy Policy</Link> <Link to="/terms-and-condition">Terms and Condition</Link></p>
                   <p className="dh-policy"><Link to="/advertisement-policy">Advertisement Policy</Link></p>
                  <p className="dh-policy">Dreamers Health ©  2025. All rights reserved.</p>
               </div>
            </div>
         </nav>
      </div>
   );
};
export default SideBar;
